// {{{ Startup

function reportException(ex) {
	/*
	 * We don't want to report REST API aborts caused by a signal.
	 */
	if (ex instanceof AbortError) {
		return;
	}

	if (ex instanceof RESTError) {
		if (ex.status == 502) {
			Application.notify({
				kind: 'error',
				text: _('Aplikace není nyní dostupná (server se restartuje, nebo selhal)'),
				priority: 10,
				timeout: 4000,
			});
			return;
		}

		Application.notify({
			kind: 'error',
			text: ex.serverError ? ex.serverError : _('Chyba serveru') + ': ' + ex.message,
			priority: 5,
			timeout: 5000,
		});
	} else if (ex instanceof Error) {
		Application.notify({
			kind: 'error',
			text: _('Neošetřená výjimka') + ': ' + ex.message,
			priority: 5,
			timeout: 5000,
		});

		Performance.pushEvent({
			kind: 'error',
			ex,
			stack: ex.stack,
		});
	}
}

GW.ready(function() {
	// check for stylesheet changes and reload styles automatically
	function reloadStyles() {
		document.querySelectorAll('link[rel=stylesheet]').forEach(el => {
			if (!el.origHref) {
				el.origHref = el.href;
			}

			el.href = el.origHref + '?_ts=' + new Date().getTime();
		});
	}

	window.addEventListener('keydown', ev => {
		if (ev.key == 'F4') {
			ev.preventDefault();
			reloadStyles();
		}
	}, true);

	window.onerror = function(msg, url, line, pos, err) {
		reportException(err);
	};

	window.onunhandledrejection = ev => {
		console.log(ev);
		if (ev.reason instanceof AbortError) {
			ev.preventDefault();
		}

                reportException(ev.reason);
	};

	Application.run();
});

// }}}
